import { render, staticRenderFns } from "./GoodsOrderStatisticsList.vue?vue&type=template&id=dd3db7a6&scoped=true"
import script from "./GoodsOrderStatisticsList.vue?vue&type=script&lang=js"
export * from "./GoodsOrderStatisticsList.vue?vue&type=script&lang=js"
import style0 from "./GoodsOrderStatisticsList.vue?vue&type=style&index=0&id=dd3db7a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd3db7a6",
  null
  
)

export default component.exports